<template>
  <v-card class="mx-auto entry-container mt-3" elevation="11">
    <v-card-title
      :class="mobile ? 'justify-center bg-tfsc' : 'justify-start bg-tfsc'"
    >
      <v-row>
        <v-col :cols="mobile ? '12' : '9'">
          <span
            :class="
              mobile ? 'text-center justify-center' : 'text-h5 justify-start'
            "
            >Payment Information</span
          ></v-col
        ><v-col>
          <v-row :class="mobile ? 'justify-center' : 'justify-end'">
            <v-btn
              small
              color="grey"
              class="back-button"
              @click="$emit('setShow', 'pay')"
              >Back</v-btn
            >
          </v-row>
        </v-col>
      </v-row>
    </v-card-title>
    <hr />
    <v-card-text class="m-0 p-0 mt-1">
      <!-- Name, Age -->
      <v-row>
        <v-col :cols="mobile ? '12' : '3'" class="pt-4 font-weight-bold"
          >Full Name</v-col
        >
        <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
          <v-text-field
            label="Full name"
            v-model="apptData.customer_data.name"
            type="text"
          ></v-text-field>
        </v-col>
        <v-col :cols="mobile ? '12' : '3'" class="pt-4 font-weight-bold"
          >Number of People</v-col
        >
        <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
          <v-text-field
            v-model="apptData.customer_data.occupancy"
            type="number"
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Phone, Email -->
      <v-row>
        <v-col :cols="mobile ? '12' : '3'" class="pt-4 font-weight-bold"
          >Phone</v-col
        >
        <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
          <b-form-group>
            <v-text-field
              label="Mobile"
              v-model="apptData.customer_data.phone_number"
              type="tel"
            ></v-text-field>
          </b-form-group>
        </v-col>
        <v-col :cols="mobile ? '12' : '3'" class="pt-4 font-weight-bold"
          >Email</v-col
        >
        <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
          <b-form-group>
            <v-text-field
              label="Email"
              v-model="apptData.customer_data.email"
              type="email"
            ></v-text-field>
          </b-form-group>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="mobile ? '12' : '3'" class="pt-4  font-weight-bold"
          >Organisation Name</v-col
        >
        <v-col :cols="mobile ? '12' : '3'" class="pt-3 font-weight-bold">
          <v-text-field
            label="Organisation"
            id="organisationName"
            name="organisationName"
            v-model="apptData.customer_data.orgName"
          />
        </v-col>
        <v-col :cols="mobile ? '12' : '3'" class="pt-4  font-weight-bold"
          >Do you want to be part of our Email Marketing List?</v-col
        >
        <v-col :cols="mobile ? '12' : '3'" class="pt-3  font-weight-bold">
          <v-checkbox
            id="v-checkbox-booking"
            input-value="Y"
            name="marketingOptions"
            v-model="apptData.customer_data.marketing"
            label="Agree"
            color="success"
            hide-details
            required
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-row
        :class="
          mobile
            ? 'd-flex w-100 mt-5 mb-3 text-center justify-center'
            : 'd-flex w-100 mt-5 mb-3 text-center justify-end'
        "
      >
        <v-btn
          type="button"
          v-on:click="$emit('onCancel')"
          color="red"
          class="kb-btn bespoke-margin"
        >
          Cancel
        </v-btn>
        <v-btn
          type="submit"
          id="checkout-button"
          class="rounded bespoke-margin"
          color="success"
          x-large
          @click="$emit('onSubmit')"
        >
          Make Payment
        </v-btn>
      </v-row>
    </v-card-actions>
    <v-row class="bespoke-margin">
      <v-col class="w-100" cols="12" v-if="errors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li class="text-danger" v-bind:key="error.id" v-for="error in errors">
            {{ error }}
          </li>
        </ul>
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center text-center m-1 " cols="12">
      <v-alert
        class="text-center m-1 mb-0"
        color="green"
        dark
        type="success"
        dense
        outlined
        :icon="false"
        v-if="dataSuccess"
        >Your data was updated successfully
      </v-alert>
      <v-alert
        class="text-center w-100 m-1 mb-0"
        color="red"
        dark
        type="error"
        dense
        outlined
        :icon="false"
        v-if="notAvailable !== ''"
        >{{ notAvailable }}
      </v-alert>
      <v-alert
        class="text-center m-1 mb-0"
        color="red"
        dark
        type="error"
        dense
        outlined
        :icon="false"
        v-if="dataError"
        >Your data was not updated. Please call Intranet and Email Admin.
        <br />
        {{ dataErrorMessage }}
      </v-alert>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "Customer",
  props: [
    "apptData",
    "mobile",
    "errors",
    "dataSuccess",
    "notAvailable",
    "dataError"
  ],
  data() {
    return {
      marketingOptions: [
        { text: "Yes", value: "Y" },
        { text: "No", value: "N" }
      ]
    };
  }
};
</script>
